import AuthPage from '@/user/pages/AuthPage'
import React from 'react'

export default function Homepage() {
  return <AuthPage />
}
